import type { GraphRendererPluginInterface } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { Graphics } from 'pixi.js';

/**
 * Curtain is intentionally rendered a bit larger in all directions than it has to be
 * to avoid glitches of elements on the edge.
 */
const CURTAIN_OVERLAP = 200;

/**
 * Create a curtain over the whole graph area
 */
export const createCurtain = (
  pluginInterface: GraphRendererPluginInterface,
): [curtain: Graphics, drawCurtain: () => void] => {
  const curtain = new Graphics();
  const drawCurtain = () => {
    curtain.clear();
    pipe(
      pluginInterface.getGraphBounds(),
      option.map((bounds) => {
        curtain.beginFill(0xffffff);
        curtain.drawRect(
          bounds.left - CURTAIN_OVERLAP,
          bounds.top - CURTAIN_OVERLAP,
          bounds.right - bounds.left + 2 * CURTAIN_OVERLAP,
          bounds.bottom - bounds.top + 2 * CURTAIN_OVERLAP,
        );
        curtain.endFill();
      }),
    );
  };
  return [curtain, drawCurtain];
};
